<template>
  <div>
    <a-modal
      :title="$t('preInvoice.generate')"
      centered
      v-model="show_model"
      :okText="$t('save')"
      :cancelText="$t('cancel')"
      :okButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-primary' }"
      :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
      :confirmLoading="waiting"
      @cancel="onCanel"
      @ok="generate"
    >
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{ $t('preInvoice.subProgram') }}</label>
          <a-select
            :showSearch="true"
            :placeholder="$t('select')"
            :loading="subloading"
            :options="subProgramOptions"
            optionFilterProp="children"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @focus="getSubProgram"
            @change="subProgramChange"
            style="width: 100%"
            v-model="model.acps_id"
          ></a-select>
          <div class="validate" v-if="errors.has('acps_id')">
            {{ errors.first('acps_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{
            $t('preInvoice.academicTermName')
          }}</label>
          <a-select
            :showSearch="true"
            :placeholder="$t('select')"
            :loading="ac_term_loading"
            :options="termOptions"
            optionFilterProp="children"
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            style="width: 100%"
            v-model="model.new_ac_term_id"
          ></a-select>
          <div class="validate" v-if="errors.has('new_ac_term_id')">
            {{ errors.first('new_ac_term_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required">{{ $t('preInvoice.date') }}</label>
          <a-date-picker
            style="width: 100%"
            format="DD-MM-YYYY"
            v-model="model.pre_invoice_date"
            :placeholder="$t('preinvoice.ddmmyyyy')"
          />
          <div class="validate" v-if="errors.has('pre_invoice_date')">
            {{ errors.first('pre_invoice_date') }}
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'generatePreInvoice',
  props: ['value'],
  data() {
    return {
      show_model: false,
      subloading: false,
      ac_term_loading: false,
      subProgramOptions: [],
      termOptions: [],
      errors: new Errors(),
      waiting: false,
      model: {
        acps_id: '',
        new_ac_term_id: '',
        pre_invoice_date: moment()
      }
    }
  },
  methods: {
    getSubProgram() {
      if (!this.subProgramOptions.length > 0) {
        this.subloading = true
        this.$store
          .dispatch('preInvoice/getSubProgram', {
            page: -1,
            fields: {
              academic_program_subs: 'acps_id,acps_name_foreign'
            }
          })
          .then(response => {
            this.subProgramOptions = response.data.map(el => ({
              value: el.acps_id,
              label: el.acps_name_foreign
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.subloading = false
          })
      }
    },
    subProgramChange(acps_id) {
      this.ac_term_loading = true
      this.termOptions = []
      this.model.new_ac_term_id = null
      this.$store
        .dispatch('preInvoice/getAcademicTerm', {
          page: -1,
          fields: {
            academic_terms: 'ac_term_id,term_name'
          },
          filter: {
            acps_id: acps_id,
            ac_status_id: '1,3'
          }
        })
        .then(response => {
          this.termOptions = response.data.map(el => ({
            value: el.ac_term_id,
            label: el.term_name
          }))
        })
        .finally(() => {
          this.ac_term_loading = false
        })
    },
    generate() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'preInvoice/generatePreInvoice',
          Object.assign({}, this.model, {
            pre_invoice_date: this.model.pre_invoice_date.format('DD-MM-YYYY')
          })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onCanel() {
      this.clearInput()
      this.$emit('cancel', false)
    },
    clearInput() {
      this.model = {
        acps_id: null,
        new_ac_term_id: null,
        pre_invoice_date: moment()
      }
    }
  },
  watch: {
    value: function(value) {
      this.show_model = value
    }
  }
}
</script>
